export type ApplicationLoader = () => Promise<unknown>

/** Local bootstrap copy pinned to BOOT_BLOCK_ATTRIBUTE by a unit test. */
export const BOOT_BLOCK_ATTRIBUTE_COPY = 'data-coach-unsupported-browser'

export async function loadApplicationIfSupported(
  root: Element | null,
  loadApplication: ApplicationLoader,
): Promise<boolean> {
  if (!root) throw new Error('Root element not found')
  if (root.hasAttribute(BOOT_BLOCK_ATTRIBUTE_COPY)) return false
  await loadApplication()
  return true
}
